import { Component, ElementRef, OnDestroy, OnInit } from '@angular/core';
import {
  PostRequestBase,
  ResponseBase,
  ScreenModel,
} from '../../../../core/models/common';
import { interval, Subscription } from 'rxjs';
import { ApiService } from '../../../../core/services/api-mock.service';
import { GlobalsService } from '../../../../core/services/globals.service';
import { ConfirmationModel } from '../confirmation/confirmation.component';
import { startWith, switchMap } from 'rxjs/operators';
import { Router } from '@angular/router';

@Component({
  selector: 'app-confirmation-loading',
  templateUrl: './confirmation-loading.component.html',
  styleUrls: ['./confirmation-loading.component.scss'],
})
export class ConfirmationLoadingComponent implements OnInit, OnDestroy {
  // Variables to poll for docusign status
  timeInterval: Subscription | undefined;

  constructor(
    private router: Router,
    private apiService: ApiService,
    public globals: GlobalsService,
  ) {}

  ngOnInit(): void {
    this.pollForDocusignStatus();
  }

  ngOnDestroy() {
    console.log('ConfirmationLoadingComponent.ngOnDestroy');
    this.timeInterval?.unsubscribe();
  }

  pollForDocusignStatus = async () => {
    this.timeInterval = interval(5000)
      .pipe(
        startWith(0),
        switchMap(() => this.apiService.pollingDocusignStatus()),
      )
      .subscribe(async (res) => {
        console.log('Polling...');
        if (res.Status === 'Complete') {
          console.log('Stopping poll....');
          this.timeInterval?.unsubscribe();
          await this.router.navigateByUrl('/fna/confirmation');
          return;
        }
      });
  };
}
